<template>
	<v-dialog
		v-model="showDialog"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		max-width="600px"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 在庫詳細 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<v-row no-gutters justify="end">
					<ConstructionPartiallyUsedNewDialog
						v-if="type == 'rubber' || type == 'item_kg'"
						:type="type"
						@create-item="createPartiallyUsedItem($event)"
					/>
					<ConstructionStockEditDialog :type="type" :item="item" @click="updateItem($event)" />
					<ConstructionStockHistoryIndexDialog :type="type" :item="item" />
				</v-row>
				<div class="mt-4">
					<!-- ゴム -->
					<table v-if="type == 'rubber'" class="show-dialog-table" width="100%">
						<tbody>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">材料名</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">ロット</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">厚み(mm)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">幅(mm)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">長さ(新品)(m)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold border-right" rowspan="3" width="25%">新品本数</th>
								<th class="font-weight-bold" width="15%">総本数</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="15%">引当済</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="15%">未引当</th>
								<td width="60%">XXX</td>
							</tr>
							<!-- TODO: コメントアウト部分を修正して、 -->
							<!-- <template v-for="(item, i) in item.partially_used_items">
								<tr :key="`length-${i}`">
									<th class="font-weight-bold border-right" rowspan="4" width="25%">使いさし{{ i + 1 }}
										<v-btn @click="openDeleteDialog(item)" icon>
											<v-icon>mdi-delete</v-icon>
										</v-btn>
                  </th>
									<th class="font-weight-bold" width="15%">長さ(m)</th>
									<td width="60%"></td>
								</tr>
								<tr :key="`total-${i}`">
									<th class="font-weight-bold" width="15%">総本数</th>
									<td width="60%"></td>
								</tr>
								<tr :key="`reserved-${i}`">
									<th class="font-weight-bold" width="15%">引当済</th>
									<td width="60%"></td>
								</tr>
								<tr :key="`available-${i}`">
									<th class="font-weight-bold" width="15%">未当済</th>
									<td width="60%"></td>
								</tr>
							</template> -->
							<!-- NOTE: 表示用サンプルデータ -->
							<template v-for="i of 2">
								<tr :key="`length-${i}`">
									<th class="font-weight-bold border-right" rowspan="4" width="25%">
										使いさし{{ i }}
										<v-btn @click="openDeleteDialog(i)" icon>
											<v-icon>mdi-delete</v-icon>
										</v-btn>
									</th>
									<th class="font-weight-bold" width="15%">長さ(m)</th>
									<td width="60%">XX</td>
								</tr>
								<tr :key="`total-${i}`">
									<th class="font-weight-bold" width="15%">総本数</th>
									<td width="60%">XX</td>
								</tr>
								<tr :key="`reserved-${i}`">
									<th class="font-weight-bold" width="15%">引当済</th>
									<td width="60%">XX</td>
								</tr>
								<tr :key="`available-${i}`">
									<th class="font-weight-bold" width="15%">未当済</th>
									<td width="60%">XX</td>
								</tr>
							</template>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">総在庫数(m)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">総引当済数(m)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">総引当可能数(m)</th>
								<td width="60%">XXX</td>
							</tr>
						</tbody>
					</table>

					<!-- その他 kg単位 -->
					<table v-if="type == 'item_kg'" class="show-dialog-table" width="100%">
						<tbody>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">材料名</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">ロット</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">入り目(kg)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold border-right" rowspan="3" width="25%">新品缶数</th>
								<th class="font-weight-bold" width="15%">総缶数</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="15%">引当済</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="15%">未引当</th>
								<td width="60%">XXX</td>
							</tr>
							<!-- TODO: コメントアウト部分を修正して、 -->
							<!-- <template v-for="(item, i) in item.partially_used_items">
								<tr :key="`length-${i}`">
									<th class="font-weight-bold border-right" rowspan="4" width="25%">使いさし{{ i + 1 }}
										<v-btn @click="openDeleteDialog(item)" icon>
											<v-icon>mdi-delete</v-icon>
										</v-btn>

                  </th>
									<th class="font-weight-bold" width="15%">重量</th>
									<td width="60%"></td>
								</tr>
								<tr :key="`status-${i}`">
									<th class="font-weight-bold" width="15%">状態</th>
									<td width="60%"></td>
								</tr>
							</template> -->
							<!-- NOTE: 表示用サンプルデータ -->
							<template v-for="i of 2">
								<tr :key="`length-${i}`">
									<th class="font-weight-bold border-right" rowspan="2" width="25%">
										使いさし{{ i }}
										<v-btn @click="openDeleteDialog(item)" icon>
											<v-icon>mdi-delete</v-icon>
										</v-btn>
									</th>
									<th class="font-weight-bold" width="15%">重量</th>
									<td width="60%">XX</td>
								</tr>
								<tr :key="`status-${i}`">
									<th class="font-weight-bold" width="15%">状態</th>
									<td width="60%">XX</td>
								</tr>
							</template>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">総在庫数(kg)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">総引当済数(kg)</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" colspan="2" width="40%">総引当可能数(kg)</th>
								<td width="60%">XXX</td>
							</tr>
						</tbody>
					</table>

					<!-- その他 数量単位 -->
					<table v-if="type == 'item_quantity'" class="show-dialog-table" width="100%">
						<tbody>
							<tr>
								<th class="font-weight-bold" width="40%">材料名</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="40%">ロット</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="40%">在庫数</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="40%">引当済数</th>
								<td width="60%">XXX</td>
							</tr>
							<tr>
								<th class="font-weight-bold" width="40%">引当可能数</th>
								<td width="60%">XXX</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</v-card>
		<ConstructionPartiallyUsedDeleteDialog
			:dialog.sync="deleteDialog"
			:type="type"
			:partially_used_item="partially_used_item"
			@delete-item="deletePartiallyUsedItem($event)"
		/>
	</v-dialog>
</template>

<script>
import ConstructionPartiallyUsedNewDialog from "./ConstructionPartiallyUsedNewDialog.vue"
import ConstructionPartiallyUsedDeleteDialog from "./ConstructionPartiallyUsedDeleteDialog.vue"
import ConstructionStockEditDialog from "./ConstructionStockEditDialog.vue"
import ConstructionStockHistoryIndexDialog from "./ConstructionStockHistoryIndexDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		type: {
			type: String,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
	},
	components: {
		ConstructionPartiallyUsedNewDialog,
		ConstructionPartiallyUsedDeleteDialog,
		ConstructionStockEditDialog,
		ConstructionStockHistoryIndexDialog,
	},
	data() {
		return {
			deleteDialog: false,
			partially_used_item: null,
		}
	},
	methods: {
		deletePartiallyUsedItem(item) {
			// TODO: 削除処理
		},
		createPartiallyUsedItem(item) {
			// TODO: 作成処理
		},
		updateItem(item) {
			// TODO: 更新処理
		},
		openDeleteDialog(item) {
			this.partially_used_item = item
			this.deleteDialog = true
		},
		closeDialog() {
			this.showDialog = false
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.border-right {
	border-right: 1px solid white;
}
</style>